"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caianello": {
    "9a3ac7be": [{
      "hkey": "bcba2c61",
      "slug": "caianello",
      "name": "Caianello",
      "primary": true,
      "skipSearch": false
    }],
    "judea": [{
      "hkey": "bcba2c61",
      "slug": "caianello",
      "name": "Caianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff756ac0": [{
      "hkey": "f85514cb",
      "slug": "montano",
      "name": "Montano",
      "primary": true,
      "skipSearch": false
    }],
    "montano-fossato": [{
      "hkey": "f85514cb",
      "slug": "montano",
      "name": "Montano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;